import { InputFieldNumber as LibInputFieldNumber } from 'qampo-ui-library';

interface InputFieldNumberProps {
  label?: string;
  value?: number | null;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  width?: string;
  disable?: boolean;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  suffixLabel?: string;
  showArrows?: boolean;
  step?: number;
  textAlign?: 'left' | 'right';
  allowNegative?: boolean;
  allowDecimal?: boolean;
  maxLimit?: number;
  maxLength?: number;
  style?: React.CSSProperties;
  classes?: string;
  styles?: {
    root?: React.CSSProperties;
    labelText?: React.CSSProperties;
    input?: React.CSSProperties;
    inputWrapper?: React.CSSProperties;
    helperText?: React.CSSProperties;
    suffixLabel?: React.CSSProperties;
    arrowsWrapper?: React.CSSProperties;
  };
}

const defaultStyles: InputFieldNumberProps['styles'] = {
  input: {
    background: 'var(--color-surface-primary)',
    borderRadius: 'var(--radius-regular)',
    padding: '6px 16px',
    border: '1px solid var(--color-border-primary)'
  },
  // The library pins the suffix to a fixed 45px box, so longer labels ("week(s)",
  // "uge(r)") spill past the input's right edge. Sizing to content keeps it inside;
  // because it stays anchored right, short suffixes ("min", "kr.") only move toward
  // the edge, never further into the value.
  suffixLabel: {
    width: 'auto',
    whiteSpace: 'nowrap'
  }
};

export const InputFieldNumber = ({ styles, ...props }: InputFieldNumberProps) => {
  const mergedStyles = {
    ...defaultStyles,
    ...styles,
    input: { ...defaultStyles.input, ...styles?.input },
    suffixLabel: { ...defaultStyles.suffixLabel, ...styles?.suffixLabel }
  };
  return <LibInputFieldNumber {...props} styles={mergedStyles} />;
};
